import CardComponent from "./CardComponent";

export class ViewProfileAndLabels extends CardComponent {

}
